(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["linfatic-mx-pdp"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const money = (cents, currency) => {
      try {
        return new Intl.NumberFormat('es-MX', {
          style: 'currency',
          currency,
          maximumFractionDigits: cents % 100 === 0 ? 0 : 2
        }).format(cents / 100);
      } catch {
        return `$${(cents / 100).toFixed(2)}`;
      }
    };

    document.querySelectorAll('[data-lpdp]').forEach((root) => {
      if (root.dataset.ready === 'true') return;
      root.dataset.ready = 'true';
      root.classList.add('lpdp-ready');

      const main = root.querySelector('[data-lpdp-gallery-main]');
      const activeImage = main?.querySelector('.lpdp-gallery__active-image');
      const thumbs = Array.from(root.querySelectorAll('[data-lpdp-gallery-thumb]'));
      thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
          if (!main || !activeImage || thumb.classList.contains('is-active')) return;
          main.classList.add('is-changing');
          window.setTimeout(() => {
            activeImage.src = thumb.dataset.src;
            activeImage.removeAttribute('srcset');
            activeImage.alt = thumb.dataset.alt || '';
            main.dataset.fit = thumb.dataset.fit || 'cover';
            thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
            main.classList.remove('is-changing');
          }, 170);
        });
      });

      const packs = Array.from(root.querySelectorAll('[data-lpdp-pack]'));
      const packCards = Array.from(root.querySelectorAll('[data-lpdp-pack-card]'));
      const totals = root.querySelectorAll('[data-lpdp-total]');
      const stickyTotal = root.querySelector('[data-lpdp-sticky-total]');
      const stickyQuantity = root.querySelector('[data-lpdp-sticky-quantity]');
      const stickyUnit = root.querySelector('[data-lpdp-sticky-unit]');
      const status = root.querySelector('[data-lpdp-status]');
      let selectedPack = packs.find((pack) => pack.checked) || packs[0];

      const updatePack = (pack) => {
        selectedPack = pack;
        packCards.forEach((card) => card.classList.toggle('is-selected', card.contains(pack)));
        totals.forEach((node) => {
          node.textContent = money(Number(pack.dataset.total), root.dataset.currency);
        });
        if (stickyTotal) stickyTotal.textContent = money(Number(pack.dataset.total), root.dataset.currency);
        if (stickyQuantity) stickyQuantity.textContent = `${pack.dataset.quantity} frascos`;
        if (stickyUnit) stickyUnit.textContent = `${money(Number(pack.dataset.unit), root.dataset.currency)} c/u`;
      };

      packs.forEach((pack) => pack.addEventListener('change', () => updatePack(pack)));

      const purchase = async (button) => {
        if (!selectedPack || button.disabled) return;
        const initialText = button.textContent;
        button.disabled = true;
        button.textContent = 'Agregando…';
        if (status) status.textContent = '';

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              items: [{
                id: Number(root.dataset.variantId),
                quantity: Number(selectedPack.dataset.quantity)
              }]
            })
          });

          if (!response.ok) throw new Error('Cart request failed');
          const code = selectedPack.dataset.code;
          const checkout = code ? `/discount/${encodeURIComponent(code)}?redirect=/checkout` : '/checkout';
          window.location.assign(checkout);
        } catch {
          button.disabled = false;
          button.textContent = initialText;
          if (status) status.textContent = root.dataset.purchaseError;
        }
      };

      root.querySelectorAll('[data-lpdp-buy], [data-lpdp-sticky-buy]').forEach((button) => {
        button.addEventListener('click', () => purchase(button));
      });

      const sticky = root.querySelector('[data-lpdp-sticky]');
      const productArea = root.querySelector('.lpdp-product');
      if (sticky && productArea && 'IntersectionObserver' in window) {
        const stickyObserver = new IntersectionObserver(([entry]) => {
          sticky.classList.toggle('is-visible', !entry.isIntersecting);
        }, { threshold: 0.08 });
        stickyObserver.observe(productArea);
      }

      const revealNodes = root.querySelectorAll('[data-lpdp-reveal]');
      if ('IntersectionObserver' in window) {
        const revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          });
        }, { threshold: 0.12 });
        revealNodes.forEach((node) => revealObserver.observe(node));
      } else {
        revealNodes.forEach((node) => node.classList.add('is-visible'));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["linfatic-mx-product-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-lmx3-root]');
    const money = (cents, currency) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'es-MX', {
          style: 'currency',
          currency,
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        }).format(Number(cents || 0) / 100);
      } catch (_error) {
        return `$${(Number(cents || 0) / 100).toFixed(2)}`;
      }
    };

    roots.forEach((root) => {
      if (root.dataset.lmx3Ready === 'true') return;
      root.dataset.lmx3Ready = 'true';
      root.classList.add('lmx3-ready');

      const variantsNode = root.querySelector('[data-lmx3-variants]');
      let variants = [];
      try {
        variants = JSON.parse(variantsNode?.textContent || '[]');
      } catch (_error) {
        variants = [];
      }

      const variant = variants.find((item) => String(item.id) === String(root.dataset.variantId))
        || variants.find((item) => item.available)
        || variants[0];
      const currency = root.dataset.currency || 'MXN';
      const packInputs = Array.from(root.querySelectorAll('[data-lmx3-pack]'));
      const buyButtons = Array.from(root.querySelectorAll('[data-lmx3-buy], [data-lmx3-sticky-buy]'));
      const totalNodes = root.querySelectorAll('[data-lmx3-total], [data-lmx3-button-total], [data-lmx3-sticky-total]');
      const titleNodes = root.querySelectorAll('[data-lmx3-summary-title], [data-lmx3-sticky-title]');
      const compareNode = root.querySelector('[data-lmx3-compare-price]');
      const message = root.querySelector('[data-lmx3-message]');
      const offer = root.querySelector('[data-lmx3-offer]');
      const sticky = root.querySelector('[data-lmx3-sticky]');
      let selectedPack = packInputs.find((input) => input.checked) || packInputs[0];
      let loading = false;

      const packData = () => ({
        quantity: Math.max(1, Number(selectedPack?.dataset.quantity || 1)),
        discount: Math.max(0, Math.min(100, Number(selectedPack?.dataset.discount || 0))),
        code: (selectedPack?.dataset.code || '').trim(),
        title: selectedPack?.dataset.title || ''
      });

      const priceData = () => {
        const pack = packData();
        const unit = Number(variant?.price || 0);
        const compareUnit = Number(variant?.compare_at_price || 0);
        const subtotal = unit * pack.quantity;
        const total = Math.round(subtotal * (100 - pack.discount) / 100);
        const compare = Math.max(subtotal, compareUnit * pack.quantity);
        return { pack, unit, subtotal, total, compare };
      };

      const renderSelection = () => {
        packInputs.forEach((input) => {
          input.closest('[data-lmx3-pack-card]')?.classList.toggle('is-selected', input === selectedPack);
        });

        const pricing = priceData();
        totalNodes.forEach((node) => { node.textContent = money(pricing.total, currency); });
        titleNodes.forEach((node) => { node.textContent = pricing.pack.title; });
        if (compareNode) {
          compareNode.hidden = pricing.compare <= pricing.total;
          compareNode.textContent = pricing.compare > pricing.total ? money(pricing.compare, currency) : '';
        }

        packInputs.forEach((input) => {
          const quantity = Math.max(1, Number(input.dataset.quantity || 1));
          const discount = Math.max(0, Math.min(100, Number(input.dataset.discount || 0)));
          const total = Math.round(Number(variant?.price || 0) * quantity * (100 - discount) / 100);
          const totalNode = input.closest('[data-lmx3-pack-card]')?.querySelector('[data-lmx3-pack-total]');
          if (totalNode) totalNode.textContent = money(total, currency);
        });
      };

      packInputs.forEach((input) => {
        input.addEventListener('change', () => {
          if (!input.checked) return;
          selectedPack = input;
          const update = () => renderSelection();
          if (document.startViewTransition && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            document.startViewTransition(update);
          } else {
            update();
          }
        });
      });

      root.querySelectorAll('a[href^="#"]').forEach((anchor) => {
        anchor.addEventListener('click', (event) => {
          const target = root.querySelector(anchor.getAttribute('href'));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
        });
      });

      root.querySelectorAll('[data-lmx3-comparison]').forEach((comparison) => {
        comparison.querySelector('[data-lmx3-comparison-range]')?.addEventListener('input', (event) => {
          comparison.style.setProperty('--lmx3-split', `${event.currentTarget.value}%`);
        });
      });

      const reveals = root.querySelectorAll('[data-reveal]');
      if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const revealObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
        reveals.forEach((node) => revealObserver.observe(node));
      } else {
        reveals.forEach((node) => node.classList.add('is-visible'));
      }

      if (sticky && offer) {
        let stickyFrame = 0;
        const updateSticky = () => {
          const offerRect = offer.getBoundingClientRect();
          const outsideOffer = offerRect.top > window.innerHeight || offerRect.bottom < 0;
          const visible = window.scrollY > 520 && outsideOffer;
          sticky.classList.toggle('is-visible', visible);
          sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
          stickyFrame = 0;
        };
        const requestStickyUpdate = () => {
          if (stickyFrame) return;
          stickyFrame = window.requestAnimationFrame(updateSticky);
        };
        window.addEventListener('scroll', requestStickyUpdate, { passive: true });
        window.addEventListener('resize', requestStickyUpdate);
        updateSticky();
      }

      const setLoading = (value) => {
        loading = value;
        buyButtons.forEach((button) => {
          button.disabled = value || !variant?.available;
          button.classList.toggle('is-loading', value);
          button.setAttribute('aria-busy', value ? 'true' : 'false');
        });
      };

      const purchase = async () => {
        if (loading || !variant?.id || !variant.available) return;
        const pricing = priceData();
        setLoading(true);
        if (message) message.textContent = '';

        try {
          const rootRoute = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${rootRoute}cart/add.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{
                id: Number(variant.id),
                quantity: pricing.pack.quantity,
                properties: {
                  '_Linfatic - Rutina': pricing.pack.title
                }
              }]
            })
          });
          const data = await response.json();
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || root.dataset.purchaseError);
          }

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'linfatic_add_to_cart',
            ecommerce: {
              currency,
              value: pricing.total / 100,
              items: [{
                item_id: String(variant.id),
                item_name: root.dataset.productTitle,
                price: pricing.total / pricing.pack.quantity / 100,
                quantity: pricing.pack.quantity
              }]
            }
          });

          const checkout = `${rootRoute}checkout`;
          const destination = pricing.pack.code
            ? `${rootRoute}discount/${encodeURIComponent(pricing.pack.code)}?redirect=${encodeURIComponent(checkout)}`
            : checkout;
          window.location.assign(destination);
        } catch (error) {
          if (message) {
            message.textContent = error instanceof Error && error.message
              ? error.message
              : root.dataset.purchaseError;
          }
          setLoading(false);
        }
      };

      buyButtons.forEach((button) => button.addEventListener('click', purchase));
      renderSelection();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["linfatic-pdp-mobile"] && !Shopify.designMode) return;
  try {
    
function initLinfaticPdp(root) {
  if (root.dataset.ready) return;
  root.dataset.ready = 'true';
  const form = root.querySelector('.lp-form');
  const radios = root.querySelectorAll('input[name="id"]');
  function syncPack(radio, updateUrl) {
    if (!radio || radio.disabled) return;
    root.querySelectorAll('[data-total]').forEach(el => { el.textContent = radio.dataset.price; });
    root.querySelectorAll('[data-pack-label]').forEach(el => { el.textContent = radio.dataset.label; });
    if (updateUrl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', radio.value);
      window.history.replaceState({}, '', url);
    }
  }
  radios.forEach(radio => radio.addEventListener('change', () => syncPack(radio, true)));
  syncPack(root.querySelector('input[name="id"]:checked'), false);
  window.addEventListener('pageshow', () => syncPack(root.querySelector('input[name="id"]:checked'), false));
  root.querySelectorAll('[data-image]').forEach(button => {
    button.addEventListener('click', () => {
      const image = root.querySelector('.lp-main-image');
      if (!image) return;
      image.removeAttribute('srcset');
      image.src = button.dataset.image;
      image.alt = button.dataset.alt || '';
      root.querySelectorAll('[data-image]').forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
    });
  });
  const sticky = root.querySelector('.lp-sticky');
  if (form && sticky && 'IntersectionObserver' in window) {
    const buyButton = form.querySelector('.lp-buy');
    const intro = root.querySelector('.lp-intro');
    let introVisible = true;
    let buyVisible = false;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === intro) introVisible = entry.isIntersecting;
        if (entry.target === buyButton) buyVisible = entry.isIntersecting;
      });
      sticky.hidden = introVisible || buyVisible;
    }, { threshold: 0 });
    observer.observe(intro);
    observer.observe(buyButton);
    document.addEventListener('shopify:section:unload', event => {
      if (event.target.contains(root)) observer.disconnect();
    });
  }
}
document.querySelectorAll('[data-linfatic-pdp]').forEach(initLinfaticPdp);
document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-linfatic-pdp]').forEach(initLinfaticPdp));

  } catch(e) { console.error(e); }
})();
})();
